// import translations from 'utils/helpers/localization'

const WIDGET_TYPES = {
  LR_HEADER: 'LR_HEADER',
  PLAY_WITH_MONEY: 'PLAY_WITH_MONEY',
  CAROUSEL: 'carousel',
  IMAGE: 'image',
  MEGA_TOURNAMENT: 'MEGA_TOURNAMENT',
  MTT_HEADER: 'MTT_HEADER',
  MTT_CARD: 'MTT_CARD'
}

const WIDGET_TYPES_NX = {
  CUSTOM_IMMERSIVE_IMAGE: 'CUSTOM_IMMERSIVE_IMAGE',
  LR_HEADER: 'LR_HEADER',
  PLAY_WITH_MONEY_NX: 'PLAY_WITH_MONEY_NX',
  CAROUSEL: 'carousel',
  IMAGE: 'image',
  MEGA_TOURNAMENT: 'MEGA_TOURNAMENT',
  MAHA_MEGA_TOURNAMENT: 'MAHA_MEGA_TOURNAMENT',
  PWA_BANNER: "PWA_BANNER"
}
const ALLOWED_WIDGETS = ['LR_HEADER', 'PLAY_WITH_MONEY', 'carousel', 'image', 'MEGA_TOURNAMENT', 'MTT_HEADER', 'MTT_CARD']
const ALLOWED_WIDGETS_NX = [
  'LR_HEADER',
  'PLAY_WITH_MONEY',
  'carousel', 'image',
  'MEGA_TOURNAMENT',
  'PLAY_WITH_MONEY_NX',
  'MAHA_MEGA_TOURNAMENT'
]
const SORT_ACTION = 'ACTION'
const SORT_ORDER = 'ORDER'
const SORT_OPTION = {
  ASCENDING: 'ascending',
  DESCENDING: 'descending'
}
const SORT = 'SORT'
// const TOURNAMENT_STATUS = {
//   JOINED: translations.joined,
//   REGISTERED: translations.registered,
//   REGISTRATION_CLOSED: translations.registrationClosed,
//   ALREADY_REGISTERED: translations.alreadyRegistered
// }
const TIMER_EXPIRED_STRING = 'EXPIRED'
const RANK = 'Rank'
const NINETY_NINE_PLUS = '99+'
const QUICK_FILTER = 'QUICK_FILTER'
const ENTRY_FEE_FILTER = 'ENTRY_FEE_FILTER'
const QUICK_GAME_FILTER = 'QUICK_GAME_FILTER'
const VERIFY_TORUNAMENT = 'VERIFY_TORUNAMENT'
const TOURNAMENT_LOBBY = 'TOURNAMENT_LOBBY'
const SECONDS_60 = 60
const SECONDS_30 = 30
const SECONDS_15 = 15
const SECONDS_10 = 10
const SECONDS_0 = 0
const SECONDS_DEFAULT = -1
const TNC_LINK = 'https://zupee.com/terms-and-conditions/'
const minDiff = 2 * 60 * 1000
const maxDiff = 8 * 60 * 60 * 1000
const REGISTERED = 'REGISTERED'
const FREE = 0
const SUCCESS_GAME_JOINED_VISIBILITY_TIMER = 2000
const COUNTDOWN_SCREEN_TIMER = 13000

const IS_FIRST_TIME_REGISTER_TOURNAMENT = 'isFirstTimeRegisterTournament'

export {
  WIDGET_TYPES,
  WIDGET_TYPES_NX,
  SORT_ACTION,
  SORT_OPTION,
  SORT_ORDER,
  SORT,
//   TOURNAMENT_STATUS,
  TIMER_EXPIRED_STRING,
  RANK,
  NINETY_NINE_PLUS,
  QUICK_FILTER,
  VERIFY_TORUNAMENT,
  SECONDS_0,
  SECONDS_10,
  SECONDS_15,
  SECONDS_30,
  SECONDS_DEFAULT,
  TNC_LINK,
  ALLOWED_WIDGETS,
  ALLOWED_WIDGETS_NX,
  TOURNAMENT_LOBBY,
  minDiff,
  maxDiff,
  SECONDS_60,
  REGISTERED,
  ENTRY_FEE_FILTER,
  FREE,
  QUICK_GAME_FILTER,
  SUCCESS_GAME_JOINED_VISIBILITY_TIMER,
  COUNTDOWN_SCREEN_TIMER,
  IS_FIRST_TIME_REGISTER_TOURNAMENT
}
